<template>
    <div class="temp_box pop-up2">
        
        <div>
            <div class="temp_tit"><p>我的选书模板</p></div>
            <Row >
                 <Col :span="6" v-for="(item,i) in tagArr" :key="i" class="con"  @mouseleave.native="mouseleave">
                    <div class="item_c"  :class="{'hover':seen&&i==current}"   @click.stop="searchBook(item)" @mouseenter="mouseOver(i)" >
                        <p :title="item.name">{{item.name}}</p>
                    </div>
                    <div class="item_detail hover"  v-show="seen&&i==current">
                        <p v-if="item.pubname">出版社(包含):{{item.pubname}}</p>
                        <p v-if="item.notPubname">出版社(不包含):{{item.notPubname}}</p>
                        <p v-if="item.eqztf">中图法(等于):{{getXkfl(item.eqztf)}}</p>
                        <p v-if="item.notztf">中图法(不包含):{{getXkfl(item.notztf)}}</p>
                        <p v-if="item.ztf">中图法(包含):{{getXkfl(item.ztf)}}</p>
                        <p v-if="item.xkfl">学科分类:{{getXkfl(item.xkfl)}}</p> 
                        <p v-if="item.myfrom">码洋:{{item.myfrom}}元-{{item.myto}}元</p>
                        <p v-if="item.keyWord">关键词(包含):{{item.keyWord}}</p>
                        <p v-if="item.notKeyWord">关键词(不包含):{{item.notKeyWord}}</p>
                        <p v-if="item.eqKeyWord">关键词(等于):{{item.eqKeyWord}}</p>
                        <p v-if="item.zhuangj">装帧:{{item.zhuangj}}</p>
                        <p v-if="item.myfrom">尺寸:{{item.sizefrom}}cm-{{item.sizeto}}cm</p>
                        <p v-if="item.pageFrom">页码:{{item.pageFrom}}页-{{item.pageTo}}页</p>
                        <p v-if="item.hasCD != ''">光盘项:{{getHasCd(item.hasCD)}}</p>
                        <p v-if="item.useobj">读者类型:{{item.useobj}}</p>
                    </div>
                </Col> 
            </Row>
            <div class="temp_tit"><p>其他人在用的选书模板</p></div>
            <Row >
                 <Col :span="6" v-for="(item,i) in tagArrOther" :key="i" class="con"  @mouseleave.native="mouseleave1">
                    <div class="item_c"  :class="{'hover':seen1&&i==current1}" @click.stop="searchBook(item)"  @mouseenter="mouseOver1(i)" >
                        {{item.name}}
                    </div>
                    <div class="item_detail hover"  v-show="seen1&&i==current1">
                        <p v-if="item.pubname">出版社:{{item.pubname}}</p>
                        <p v-if="item.notPubname">出版社(不包含):{{item.notPubname}}</p>
                        <p v-if="item.eqztf">中图法(等于):{{getXkfl(item.notPubname)}}</p>
                        <p v-if="item.notztf">中图法(不包含):{{getXkfl(item.notPubname)}}</p>
                        <p v-if="item.ztf">中图法:{{getXkfl(item.notPubname)}}</p>
                        <p v-if="item.xkfl">学科分类:{{getXkfl(item.xkfl)}}</p> 
                        <p v-if="item.myfrom">码洋:{{item.myfrom}}元-{{item.myto}}元</p>
                        <p v-if="item.keyWord">关键词:{{item.keyWord}}</p>
                        <p v-if="item.notKeyWord">关键词(不包含):{{item.notKeyWord}}</p>
                        <p v-if="item.eqKeyWord">关键词(等于):{{item.eqKeyWord}}</p>
                        <p v-if="item.zhuangj">装帧:{{item.zhuangj}}</p>
                        <p v-if="item.myfrom">尺寸:{{item.sizefrom}}cm-{{item.sizeto}}cm</p>
                        <p v-if="item.pageFrom">页码:{{item.pageFrom}}页-{{item.pageTo}}页</p>
                         <p v-if="item.hasCD">光盘项:{{getHasCd(item.hasCD)}}</p>
                        <p v-if="item.useobj">读者类型:{{item.useobj}}</p>
                    </div>
                </Col> 
            </Row>
        </div>

    </div>
</template>
    
    <script>
        import {Row,Col,Input} from 'element-ui'
        import Axios from "@/api/diyaxios";
        import Cookies from 'js-cookie'

        export default {
            props: ['type'],
            components:{
                Row,Col,Input
            },
            data() {
                return {
                    tagArr:[],
                    seen:false,
                    current:0,
                    tagArrOther:[],
                    seen1:false,
                    current1:0,
                }
            },
            watch:{
            },
            created(){
                
            },
            computed:{

            },
            mounted() {
                this.getListArr('my');
                this.getListArr('other');
                
            },
            methods:{
                searchBook(item){
                    this.$emit('submit',item);
                },
                mouseOver(index){
                    this.seen = true;
                    this.current = index;
                },
                mouseleave(){
                    this.seen = false;
                    this.current = null;
                },
                mouseOver1(index){
                    this.seen1 = true;
                    this.current1 = index;
                },
                mouseleave1(){
                    this.seen1 = false;
                    this.current1 = null;
                },
                getXkfl(val){
                    var str = '',
                    val = val || '',
                    valArr = val.split('|');
                    if(valArr && valArr.length > 0){
                        str = valArr[1]
                    }
                    return str
                },
                getHasCd(val){
                    var str = '';
                    if(val == '-1'){
                        str = '全部';
                    }else if(val == '1'){
                        str = '有';
                    }else if(val == '0'){
                        str = '无';
                    }
                    return str;
                },
                getListArr(type){
                    let vm = this,
                        url = "/template/action/search",
                        obj = {};
                    if(type == 'my'){
                        obj.orgId = Cookies.get('orgGid')
                    }else{
                        obj.notOrgId = Cookies.get('orgGid')
                    }
                    Axios.post(url, { params: obj},
                            {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            }
                        ).then(res => {
                            // vm.tagArr = res.data || [];
                            vm[type=='my'?'tagArr':'tagArrOther'] = res.data || [];
                        }).catch(err => {
                    });
                },
               
            }
        }
    </script>
    
<style lang='scss'>
.temp_box{
    height: 600px;
    overflow-y: auto;
    .temp_tit{
        font-size: 22px;
        height: 22px;
        line-height: 22px;
        border-left: 5px solid #68c04a;
        padding-left: 8px;
    }
    .con{
        position: relative;
        .item_c{
            margin: 20px;
            border: 1px dashed #bbb;
            padding: 20px;
            background: #fff;
            cursor: pointer;
            p{
                overflow:hidden;  text-overflow:ellipsis; white-space:nowrap;
            }
            &.hover{
                background-color: #f0fbec;
            }
        }
        .item_detail{
            position: absolute;
            left: 0px;
            top: 60px;
            z-index: 100;
            margin: 20px;
            padding: 5px;
            border: 1px dashed #bbb;
            height: auto;
            width: 183px;
            p{
                font-size: 12px;
            }
            &.hover{
                background-color: #f0fbec;
            }
        }
    }
    
}
    
</style>


// WEBPACK FOOTER //
// src/views/getBook/bookTemp.vue